export default __webpack_public_path__ + "static/media/fb-icon.0f97201f.svg";